
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country_slug]/university",
      function () {
        return require("private-next-pages/[country_slug]/university.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country_slug]/university"])
      });
    }
  